import { newClient } from '../axios-client-factory'
import { fileClientToken } from '../axios-client-file-token'
import { requireNonNull } from '../../utils/coding-utils'


// 主播管理列表
export const getAnchorManageList = function({query, pager, sorter}) {
  return newClient().post('/guild/anchor/income/page', {
    page: pager.page,
    size: pager.limit,
    userId: requireNonNull(query.userId),
    startDt	: requireNonNull(query.applyStartTime),
    endDt: requireNonNull(query.applyEndTime)
  })
}

// 导出数据
export const exportUserDate = function ({query}) {
  return fileClientToken().post('/guild/anchor/income/export',{
    userId: requireNonNull(query.userId),
    startDt	: requireNonNull(query.applyStartTime),
    endDt: requireNonNull(query.applyEndTime)
  })
}

// 获取日薪主播状态
export const getDayAnchorState = function () {
  return newClient().post('/guild/anchor/income/state')
}

// 日薪主播管理列表
export const getDayAnchorManageList = function ({ query, pager, sorter }) {
  return newClient().post('/guild/anchor/income/dailyPage', {
    page: pager.page,
    size: pager.limit,
    userId: requireNonNull(query.userId),
    startDt	: requireNonNull(query.applyStartTime),
    endDt: requireNonNull(query.applyEndTime)
  })
}

// 导出日薪主播数据
export const exportDayUserDate = function ({query}) {
  return fileClientToken().post('/guild/anchor/income/dailyExport',{
    userId: requireNonNull(query.userId),
    startDt	: requireNonNull(query.applyStartTime),
    endDt: requireNonNull(query.applyEndTime)
  })
}

// 公会长日薪管理列表
export const getGuildAnchorManageList = function ({ query, pager, sorter }) {
  return newClient().post('/guild/anchor/income/guildPage', {
    page: pager.page,
    size: pager.limit,
    userId: requireNonNull(query.userId),
    startDt	: requireNonNull(query.applyStartTime),
    endDt: requireNonNull(query.applyEndTime)
  })
}

// 导出公会长日薪主播数据
export const exportGuildUserDate = function ({query}) {
  return fileClientToken().post('/guild/anchor/income/guildExport',{
    userId: requireNonNull(query.userId),
    startDt	: requireNonNull(query.applyStartTime),
    endDt: requireNonNull(query.applyEndTime)
  })
}

// 公会长邀请奖励 - 列表
export const getGuildInviteRewardList = function ({ query, pager, sorter }) {
  return newClient().post('/guild/anchor/income/guildAdminInvitePrize', {
    page: pager.page,
    size: pager.limit,
    userId: requireNonNull(query.userId),
    startDt	: requireNonNull(query.applyStartTime),
    endDt: requireNonNull(query.applyEndTime)
  })
}

// 公会长邀请奖励 - 导出
export const exportGuildInviteReward = function ({query}) {
  return fileClientToken().post('/guild/anchor/income/guildAdminInvitePrizeExport',{
    userId: requireNonNull(query.userId),
    startDt	: requireNonNull(query.applyStartTime),
    endDt: requireNonNull(query.applyEndTime)
  })
}



// WEBPACK FOOTER //
// ./src/api/revenues/anchor-revenues.js